import { LOGIN_USER, ERROR, NEW_TABLE, LATEST_CUPPINGS, USER_TABLES, ANOTHER_USER, UPDATE_USER, USER_TABLE_CUPPINGS, SINGLE_TABLE, SINGLE_CUPPING, UPDATE_TABLE, UPDATE_CUPPING} from '../actions/types'

const BASE_URL = process.env.REACT_APP_API_ENDPOINT


class ApiAdapter {

    getAll = async (actionModel, id, actionModel2) => {
      if (actionModel && id && actionModel2) {
        // E.g. to use for all tables that belong to user x.
        return (await (await fetch(`${BASE_URL}/api/v1/${actionModel}/${id}/${actionModel2}`)).json())
      } else if (actionModel && id) {
        return (await (await fetch(`${BASE_URL}/api/v1/${actionModel}/${id}`)).json())
      } else {
        // await below is similar to doing: return fetch(url).then(res => res.json())
        return (await (await fetch(`${BASE_URL}/api/v1/${actionModel}`)).json())
      }
    }
    
    fetchAnotherUser(anotherUserId) {
      return (dispatch) => {
          this.getAll("catadors", anotherUserId)
          .then((JSONResponse) => {
            if (JSONResponse.status === "error") {
              dispatch({ type: ERROR, payload: JSONResponse.message })	
            } else {
              dispatch({ type: ANOTHER_USER, payload: JSONResponse })	
            }
          })
          .catch(e => dispatch({ type: ERROR, payload: e.message }))
      }
    }

    fetchSingleUsrTable(tableId) {
      return (dispatch) => {
          this.getAll("tables", tableId)
          .then((JSONResponse) => {
          // console.log('%c INSIDE SINGLE_TABLE RES', 'color: aqua', JSONResponse)
          if (JSONResponse.status === "error") {
            dispatch({ type: ERROR, payload: JSONResponse.message })	
          } else {
            dispatch({ type: SINGLE_TABLE, payload: JSONResponse })	
          }
          })
          .catch(e => dispatch({ type: ERROR, payload: e.message }))
      }
    }

    fetchSingleCupping(cuppingId) {
      return (dispatch) => {
          this.getAll("cuppings", cuppingId)
          .then((JSONResponse) => {
          // console.log('%c INSIDE SINGLE_CUPPING RES', 'color: coral', JSONResponse)
          if (JSONResponse.status === "error") {
            dispatch({ type: ERROR, payload: JSONResponse.message })	
          } else {
            dispatch({ type: SINGLE_CUPPING, payload: JSONResponse })	
          }
          })
          .catch(e => dispatch({ type: ERROR, payload: e.message }))
      }
    }

    updateUser(name, imgSrc, bio, userId) {
      return (dispatch) => {
        const url = `${BASE_URL}/api/v1/catadors/${userId}`  
        // console.log(url)
        // console.log(updatedNotes)
         fetch(url, {
          method: 'PATCH',
          headers: {
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            catador: {
               name: name,
               img_src: imgSrc,
               bio: bio
            }
          })
        }).then(res => res.json())
          .then(JSONResponse => {
              // console.log('%c INSIDE UPDATE RES', 'color: aqua', JSONResponse)
              dispatch({ type: UPDATE_USER, payload: JSONResponse })
            })
          .catch(e => dispatch({ type: ERROR, payload: e.message }))  
      }
    }
    
    fetchUserTables(userID) {
      return (dispatch) => {
          this.getAll("catadors", userID, "tables")
          .then((JSONResponse) => {
            dispatch({ type: USER_TABLES, payload: JSONResponse })
            // console.log('%c INSIDE USER_TABLES RESPONSE', 'color: red', JSONResponse)
          })
          .catch(e => dispatch({ type: ERROR, payload: e.message }))
        }
    }

    fetchUsrTableCuppings(tableId) {
      return (dispatch) => {
          this.getAll("tables", tableId, "cuppings")
          .then((JSONResponse) => {
            if (JSONResponse.status === "error") {
              dispatch({ type: ERROR, payload: JSONResponse.message })	
            } else {
              dispatch({ type: USER_TABLE_CUPPINGS, payload: JSONResponse })	
            }
            // console.log('%c INSIDE USER_TABLES_CUPS RESPONSE', 'color: salmon', JSONResponse)
          })
          .catch(e => dispatch({ type: ERROR, payload: e.message }))
        }
    }
    
    fetchLatestCuppings() {
      return (dispatch) => {
          this.getAll("latest_cuppings")
          .then((JSONResponse) => {
            dispatch({ type: LATEST_CUPPINGS, payload: JSONResponse })
            // console.log('%c INSIDE LATEST CUPS RESPONSE', 'color: teal', JSONResponse)
          })
          .catch(e => dispatch({ type: ERROR, payload: e.message }))
        }
    }

  userPostOrFind(name, uid, image_src, provider){
    return (dispatch) => {
        // console.log(process.env.REACT_APP_API_ENDPOINT)
        fetch(`${BASE_URL}/api/v1/catadors`, { 
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              catador: {
                name: name,
                uid: uid,
                img_src: image_src,
                provider: provider
              }
            })
          })
            .then(response => {
              if (response.ok) {
                return response.json()
              } else {
                throw response
              }
            })

            .then(JSONResponse => {
              // console.log('%c INSIDE THE RESPONSE', 'color: navy', JSONResponse)
              dispatch({ type: LOGIN_USER, payload: JSONResponse.user })
              localStorage.setItem('jwt', JSONResponse.jwt) // the magic place to keep our token
            })
            .catch(e => dispatch({ type: ERROR, payload: e.message }))
        }
     }

     fetchCurrentUser(token) {
      return (dispatch) => {
         fetch(`${BASE_URL}/api/v1/profile`, { 
          method: 'GET',
          headers: { 
            Authorization: `Bearer ${token}`
          }
        })
          .then(response => response.json())
          // .then((JSONResponse) => dispatch({ type: LOGIN_USER, payload: JSONResponse }))
          // .then((JSONResponse) => console.log('%c INSIDE THE RESPONSE', 'color: navy', JSONResponse))
          .then((JSONResponse) => {
            if (JSONResponse && JSONResponse.message === "Please log in") {
              dispatch({ type: ERROR, payload: JSONResponse.message })
            } else {
              dispatch({ type: LOGIN_USER, payload: JSONResponse })
            }
          })
          .catch(e => dispatch({ type: ERROR, payload: e.message }))
      }
    }

    postTable(newTable, userId, userName) {
      const table = {
        newTable,
        userName
        }
  
      return (dispatch) => {
          // console.log(process.env.REACT_APP_API_ENDPOINT)
          fetch(`${BASE_URL}/api/v1/catadors/${userId}/tables`, { 
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                  table
              })
            }).then(response => response.json())
              .then(JSONResponse => {
                // console.log('%c INSIDE NEW TABLE RESPONSE', 'color: navy', JSONResponse)
                  if (JSONResponse.status === "error") {
                    dispatch({ type: ERROR, payload: JSONResponse.message })	
                } else {
                    dispatch({ type: NEW_TABLE, payload: JSONResponse })	
                }
              })
              .catch(e => dispatch({ type: ERROR, payload: e.message }))
          }
       }

      updateCupping(updates, id) {
        const cupping = {
          updates,
          }
    
        return (dispatch) => {
        const url = `${BASE_URL}/api/v1/cuppings/${id}`
        fetch(url, {
          method: 'PATCH',
          headers: {
            'content-type': 'application/json',
             Accept: 'application/json'
          },
          body: JSON.stringify({
            cupping
          })
        }).then(response => response.json())
        .then(JSONResponse => {
            // console.log('%c INSIDE UPDATE CUPPING RESPONSE', 'color: gold', JSONResponse)
            if (JSONResponse.status === "error") {
              dispatch({ type: ERROR, payload: JSONResponse.message })	
          } else {
              dispatch({ type: UPDATE_CUPPING, payload: JSONResponse })	
          }
        })
        .catch(e => dispatch({ type: ERROR, payload: e.message }))
       }
    }

    updateTable(updates, id) {
      const table = {
        updates,
        }
  
      return (dispatch) => {
      const url = `${BASE_URL}/api/v1/tables/${id}`
      
       fetch(url, {
        method: 'PATCH',
        headers: {
          'content-type': 'application/json',
           Accept: 'application/json'
        },
        body: JSON.stringify({
          table
        })
      }).then(response => response.json()) 
      .then(JSONResponse => {
          // console.log('%c INSIDE TABLE EDIT RESPONSE', 'color: salmon', JSONResponse)
          if (JSONResponse.status === "error") {
            dispatch({ type: ERROR, payload: JSONResponse.message })	
        } else {
            dispatch({ type: UPDATE_TABLE, payload: JSONResponse })	
        }
      })
      .catch(e => dispatch({ type: ERROR, payload: e.message }))
     }
    }

    deleter(model, id, dispatchType) {    
      return (dispatch) => {
        const url = `${BASE_URL}/api/v1/${model}/${id}`
        fetch(url, {
          method: 'DELETE',
          headers: {
            'content-type': 'application/json',
            Accept: 'application/json'
          },
        }).then(response => response.json()) 
        .then(JSONResponse => {
            // console.log('%c INSIDE DELETE RESPONSE', 'color: hotpink', JSONResponse)
            if (JSONResponse.status === "error") {
              dispatch({ type: ERROR, payload: JSONResponse.message })	
          } else {
              dispatch({ type: dispatchType, payload: JSONResponse })	
          }
        })
        .catch(e => dispatch({ type: ERROR, payload: e.message }))
    } 
  }

}

export default new ApiAdapter()